/**
 * Local inline-SVG trust avatars — no network request, no third-party
 * dependency, no unbounded payload. Colors were chosen to match the brand
 * gradient (blue → purple → pink → green).
 */
const AVATAR_COLORS: Array<{ bg: string; initial: string }> = [
  { bg: "#3b82f6", initial: "A" },
  { bg: "#a855f7", initial: "M" },
  { bg: "#ec4899", initial: "J" },
  { bg: "#22c55e", initial: "S" },
];

function svgAvatar({ bg, initial }: { bg: string; initial: string }) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><circle cx="40" cy="40" r="40" fill="${bg}"/><text x="50%" y="54%" text-anchor="middle" dominant-baseline="middle" font-family="system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif" font-size="34" font-weight="700" fill="#fff">${initial}</text></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

export const trustAvatars = AVATAR_COLORS.map(svgAvatar);
